import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { latestPublications } from '../../data/insightsConfig';
import { InsightCard } from '../insights/InsightCard';

const serif = { fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 };

const InsightsSection = () => (
  <section id="insights" className="py-24 md:py-32 bg-[#F8F4EE]" data-testid="home-insights-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <p className="text-[#7A5A2E] text-[11px] tracking-[0.24em] uppercase mb-5">Insights</p>
          <h2
            className="text-[#1F1812] max-w-[620px]"
            style={{ ...serif, fontSize: 'clamp(1.9rem, 3.2vw, 2.9rem)', lineHeight: 1.08, letterSpacing: '-0.02em' }}
          >
            Research, ideas, and frameworks exploring the future of project knowledge.
          </h2>
        </div>
        <div className="flex flex-col gap-4 self-start md:self-auto md:items-end">
          <div className="flex flex-col sm:flex-row sm:items-center gap-4">
            <a
              href="https://archen.beehiiv.com/subscribe"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="home-insights-subscribe"
              className="inline-flex items-center justify-center gap-2 bg-[#1F1812] text-white text-[14px] font-medium px-6 py-3 rounded-lg whitespace-nowrap transition-all duration-300 hover:bg-[#0F0D0A]"
            >
              Subscribe to Paper Trail
            </a>
            <Link
              to="/insights"
              data-testid="home-insights-explore"
              className="group inline-flex items-center gap-2 text-[#1F1812] text-[14px] font-medium whitespace-nowrap"
            >
              Explore All Insights
              <ArrowRight size={15} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
          <p data-testid="home-insights-subscribe-note" className="text-[#7A5A2E] text-[12px] md:text-right">
            Research and frameworks on project knowledge, a few times a month. No spam.
          </p>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
        {latestPublications.map((p) => <InsightCard key={p.id} pub={p} />)}
      </div>
    </div>
  </section>
);

export default InsightsSection;
